<template>
  <div class="flex items-center gap-2">
    <Badge v-for="attendee in attendees" :key="attendee" variant="blue">
      <vue-feather type="user" class="h-3" />
      <span>{{ attendee }}</span>
    </Badge>
  </div>
</template>

<script>
import { uniq } from 'lodash';
import { Badge } from '@/components/ui/badge';

export default {
  components: {
    Badge,
  },
  props: {
    eventRecording: {
      type: Object,
    },
  },
  computed: {
    attendees() {
      if (!this.eventRecording) return [];
      if (!this.eventRecording.daily_attendees) return [];

      let distinctAttendees = uniq(this.eventRecording.daily_attendees);

      return distinctAttendees.map(a => a.trim());
    },
  },
};
</script>
